import { Wrapper, Search, Separator, Total, Showing, DefaultActions } from '@/components/Grid/components/header/Heading';
import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { useOrganizationStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'
import useFilters from './useFilters'

function OrganizationGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
    events: useEvents(),
  })

  return <DefaultGrid
    heading={<Wrapper>
      <Search />
      <Separator />
      <Total />
      <Showing />
      <Separator />
      <DefaultActions />
    </Wrapper>}
  />
}

export default function OrganizationGridLayout() {
  return <GridProvider store={useOrganizationStore()}>
    <OrganizationGrid />
  </GridProvider>
}
